// extracted by mini-css-extract-plugin
export default {"star":"Stars_star__OkX-S"};